<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-8 ps-5">
                <h2 class="col pb-2 title">
                    {{ "JOBSTATUSHISTORY_TITLE" | translate }}
                </h2>
                <h6 class="col subtitle">{{ "JOBSTATUSHISTORY_SUBTITLE" | translate }}</h6>
            </div>
            <div class="col-md-4 d-flex justify-content-end align-items-center pe-5">
                @if (authService.isAuthorized([PermissionEnum.Systemmonitoring_jobstatushistory_download])) {
                    <button class="col-auto add justify-content-center" (click)="download()">
                        {{ "DOWNLOAD" | translate }}
                    </button>
                }
            </div>
        </div>
    </div>
    <div class="container g-0 m-0">
        <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
            <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
            <app-status [statuses]="commandStatuses" class="pe-2" (close)="onStatusOption($event)"></app-status>
            <div class="datepicker-container-wrapper position-relative">
                <div class="button-wrapper pe-2">
                    <div class="button">
                        <img alt="Date" src="assets/core/table-button/date.svg" />
                        <div class="button-text" (click)="toggleModal()"
                            [ngClass]="{ changed: requestData.startTime && requestData.endTime }">
                            <ng-container *ngIf="requestData.startTime && requestData.endTime; else noDateSelected">
                                {{ selectedDate }}
                            </ng-container>
                            <ng-template #noDateSelected>
                                <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                            </ng-template>
                        </div>
                        <img *ngIf="requestData.startTime && requestData.endTime" alt="Exit" src="assets/device/x.svg"
                            (click)="clearDates()" />
                    </div>
                </div>
                @if (isDatepickerOpen) {
                <div class="overlay" (click)="toggleModal()"></div>
                <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                    [inputFromDate]="requestData.startTime" [inputToDate]="requestData.endTime"></app-datepicker>
                }
            </div>
            <app-search placeholder="{{ 'SEARCHBY_JOBTYPE' | translate }}"
                (searchChange)="searchChange($event)"></app-search>
        </div>
        <div class="row g-0 m-0 pt-3">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "STARTDATE&TIME" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "ENDDATE&TIME" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "JOBTYPE" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "DEVICESETUP_STATUS" | translate }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data">
                        <td appIsNew [executedTime]="row.startTime!" [seconds]="dayInMs"></td>
                        <td>
                            <span>{{row.startTime | date: "dd MMMM yyyy hh:mm a"}}</span>
                        </td>
                        <td>
                            <span>{{row.endTime ? (row.endTime | date: "dd MMMM yyyy hh:mm a") : '-'}}</span>
                        </td>
                        <td>
                            <span>{{row.type}}</span>
                        </td>
                        <td>
                            <div class="status-container">
                                <span (click)="printResponseOfCommand($event,row)" class="text-wrapper" [ngClass]="{
                                          'status-pending': row.status === 'Pending',
                                          'status-completed': row.status === 'Success',
                                          'status-failed': row.status === 'Failed',
                                          'status-fatal-error': row.status === 'ErrorOccured',
                                        }">
                                    {{ row.status === 'ErrorOccured' ? ('FATAL_ERROR' | translate) : row.status }}
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
</div>